import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
export const client = createClient({
  projectId: '6yl1v6ro',
  dataset: 'production',
  apiVersion: '2023-04-28',
  useCdn: true,
  token:
    'skiHaCohRh41X5gZsWSjBMENGpRTNn2HOGmFkjy35TlldyEey9PjhoGQGkbhNVu3j43k7VhJfBB7VJDcA9DcQbkn6z38c1D7TeTT65bTIS9gAg0cek1FzNDb1V2L7vAIr5pkbfWqlwnbottgyB1lcrZRwNGEWVGhQQA0iDXCjYf3JGFq4MeZ',
  ignoreBrowserTokenWarning: true,
});

const builder = imageUrlBuilder(client);
export const urlFor = (source) => builder.image(source);
